import { AiProvider } from "src/context/AiContext";
import AiLayout from "./AiLayout";

export default function AiCore() {
  return (
    <AiProvider>
      <AiLayout />
    </AiProvider>
  );
}
